import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { EditClientForm } from "@/lib/core/crm/types/contacts";

interface ClientAddressSectionProps {
  editForm: UseFormReturn<EditClientForm>;
  isOpen?: boolean;
  onToggle?: () => void;
  headerless?: boolean;
}

const Fields: React.FC<{ editForm: UseFormReturn<EditClientForm> }> = ({ editForm }) => (
  <>
    <div className="space-y-2">
      <Label htmlFor="edit-address">Street Address</Label>
      <Input
        id="edit-address"
        {...editForm.register("address")}
        placeholder="123 Main Street"
      />
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div className="space-y-2">
        <Label htmlFor="edit-city">City</Label>
        <Input id="edit-city" {...editForm.register("city")} placeholder="City" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="edit-state">State</Label>
        <Input id="edit-state" {...editForm.register("state")} placeholder="State" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="edit-zip_code">ZIP Code</Label>
        <Input id="edit-zip_code" {...editForm.register("zip_code")} placeholder="ZIP Code" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="edit-country">Country</Label>
        <Input id="edit-country" {...editForm.register("country")} placeholder="Country" />
      </div>
    </div>
  </>
);

export const ClientAddressSection: React.FC<ClientAddressSectionProps> = ({
  editForm,
  isOpen,
  onToggle,
  headerless,
}) => {
  if (headerless) {
    return (
      <div className="space-y-4">
        <Fields editForm={editForm} />
      </div>
    );
  }
  return (
    <div className="border rounded-lg">
      <button
        type="button"
        className="w-full flex justify-between items-center px-4 py-3 bg-card-50 hover:bg-card-100 font-semibold text-left"
        onClick={onToggle}
      >
        Address Information
        <span>{isOpen ? "−" : "+"}</span>
      </button>
      {isOpen && (
        <div className="p-4 space-y-4">
          <Fields editForm={editForm} />
        </div>
      )}
    </div>
  );
};
